import api from "../../api/services/axiosService";
import { DOCTOR_TATVA, PM_MASTER } from "../../envConstants";

const baseUrl: any = { customBaseUrl: DOCTOR_TATVA };

export const getHistoryCount = async function () {
  let res: any = {};
  try {
    res = await api.get(`/api/v1/ddx/count`, baseUrl);
  } catch (e) {
    console.error(e);
  }
  return res;
};

export const setSSOToken = async function (payload: any) {
  let res: any = {};
  try {
    if (!PM_MASTER) {
      console.warn("PM_MASTER is not defined. Check your environment variables.");
      return res;
    }
    const config: any = {
      customBaseUrl: PM_MASTER,
    };
    res = await api.post(`/api/v1/appointment/setToken`, payload, config);
  } catch (e) {
    console.error("Error fetching SSO token:", e);
  }
  return res;
};
